import {
	Button,
	Card,
	Col,
	Form,
	Input,
	Row,
	Table,
	TimePicker,
	Typography,
} from "antd";

import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
	addShift,
	loadAllShift,
} from "../../redux/rtk/features/shift/shiftSlice";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

dayjs.extend(utc);
dayjs.extend(timezone);


function CustomTable({ list }) {
	const [columnsToShow, setColumnsToShow] = useState([]);

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			id: 2,
			title: "Name",
			dataIndex: "name",
			key: "name",
		},

		{
			id: 3,
			title: "Start Time",
			dataIndex: "startTime",
			key: "startTime",
			// render: (startTime) => dayjs(startTime).format("hh:mm A"),
			render: (startTime) => dayjs.utc(startTime).format("hh:mm A"),
		},

		{
			id: 4,
			title: "End Time",
			dataIndex: "endTime",
			key: "endTime",
			// render: (endTime) => dayjs(endTime).format("hh:mm A"),
			render: (endTime) => dayjs.utc(endTime).format("hh:mm A"),
		},
		{
			id: 5,
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id) => <ViewBtn path={`/admin/shift/${id}/`} />,
		},
	];

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	// const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));


	return (
		<Card>
			<div className='text-center my-2 flex justify-between'>
				<h5 className='department-list-title text-color-2 text-xl mb-2'>
					Shift List
				</h5>
				{list && (
					<div>
						<CsvLinkBtn>
							<CSVLink
								data={list}
								className='btn btn-dark btn-sm mb-1'
								filename='shift'>
								Download CSV
							</CSVLink>
						</CsvLinkBtn>
					</div>
				)}
			</div>

			{list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}

			<Table
				scroll={{ x: true }}
				loading={!list}
				columns={columnsToShow}
				dataSource={list ? addKeys(list) : []}
			/>
		</Card>
	);
}

const AddShift = ({ drawer }) => {
	const [loader, setLoader] = useState(false);
	const shift = useSelector((state) => state.shift.list);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(loadAllShift());
	}, []);

	const { Title } = Typography;
	const [form] = Form.useForm();

	const onFinish = async (values) => {
		const shiftData = {
			name: values.name,
			startTime: dayjs(values.startTime).format(),
			endTime: dayjs(values.endTime).format(),
		};

		setLoader(true);
		const resp = await dispatch(addShift(values));

		if (resp.payload.message === "success") {
			setLoader(false);
			form.resetFields();
			dispatch(loadAllShift());
		} else {
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding shift");
		setLoader(false);
	};
	return (
		<Fragment bordered={false}>
			<UserPrivateComponent permission={"create-shift"}>
				<Row gutter={16} className="mr-top">
					{/* Left Side - Add Shift Form */}
					<Col xs={24} sm={24} md={10} lg={8} xl={8}>
						<div className="column-design border rounded card-custom">
							<Title level={4} className="m-2 mt-5 mb-5 text-center">
								Add Shift
							</Title>
							<Form
								form={form}
								style={{ marginBottom: "40px" }}
								eventKey="shift-form"
								name="basic"
								labelCol={{ span: 6 }}
								wrapperCol={{ span: 16 }}
								onFinish={onFinish}
								onFinishFailed={onFinishFailed}
								autoComplete="off"
							>
								<Form.Item
									style={{ marginBottom: "10px" }}
									label="Name"
									name="name"
									rules={[{ required: true, message: "Please input your shift!" }]}
								>
									<Input />
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label="Start Time"
									name="startTime"
									rules={[{ required: true, message: "Please input your shift!" }]}
								>
									<TimePicker />
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "20px" }}
									label="End Time"
									name="endTime"
									rules={[{ required: true, message: "Please input your shift!" }]}
								>
									<TimePicker />
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									wrapperCol={{ offset: 6, span: 16 }}
								>
									<Button
										onClick={() => setLoader(true)}
										type="primary"
										size="large"
										htmlType="submit"
										block
										loading={loader}
									>
										Add New Shift
									</Button>
								</Form.Item>
							</Form>
						</div>
					</Col>

					{/* Right Side - Shift List Table */}
					<Col xs={24} sm={24} md={14} lg={16} xl={16}>
						<UserPrivateComponent permission={"readAll-shift"}>
							<CustomTable list={shift} />
						</UserPrivateComponent>
					</Col>
				</Row>
			</UserPrivateComponent>
		</Fragment>

	);
};

export default AddShift;
